/** @jsxImportSource @emotion/react */
import { Theme, css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { Typography } from 'chatie-design-system';

import Modal, { ModalButton, ModalProps } from '@components/common/Modal';

import { useGlobalContext } from '@contexts/global';

const containerCSS = (theme: Theme) => css`
  color: ${theme.var.gray900};
  text-align: center;
  ${Typography.body14_sentence}

  .sub-info {
    ${Typography.body12_sentence}
  }
`;

const StatInfoModal = ({ ...props }: ModalProps) => {
  const { t } = useTranslation();
  const { isCheming } = useGlobalContext();
  const text = isCheming
    ? t(
        '원하는 캐릭터와\n대화를 나눌 수 있는 대화권입니다.\n1 대화 당 1 대화권이 차감됩니다.\n\n'
      )
    : t(
        '플레이에서 원하는 캐릭터와\n대화를 나눌 수 있는 대화권입니다.\n1 대화 당 1 대화권이 차감됩니다.\n\n'
      );
  return (
    <Modal {...props} title={t('대화권')}>
      <div css={containerCSS}>
        <p className="multiline">
          {text}
          {!isCheming && (
            <span className="sub-info">
              {t(`*대화권은 모드 상관 없이 사용 가능합니다.
스마트 모드로 퀄리티 높은 대화를 즐겨보세요!`)}
            </span>
          )}
        </p>
      </div>
      <ModalButton text={t('확인')} />
    </Modal>
  );
};

export default StatInfoModal;
